import { useEffect, useState } from 'react';
import { createOperationRuns, type OperationRuns } from './operationRuns';

export const useOperationRuns = (): OperationRuns => {
  const [{ runs, setMounted }] = useState(() => {
    let mounted = true;
    return {
      runs: createOperationRuns(() => mounted),
      setMounted(value: boolean) {
        mounted = value;
      },
    };
  });

  useEffect(() => {
    setMounted(true);
    return () => {
      runs.invalidateAll();
      setMounted(false);
    };
  }, [runs, setMounted]);

  return runs;
};
